export default __webpack_public_path__ + "static/media/upload-demo.84c8bada.jpg";